import { forwardRef } from 'react';
import styles from './FullscreenPanorama.css';

export const FullscreenPanorama = forwardRef<HTMLDivElement>(function FullscreenPanorama(_, ref) {
  return <div ref={ref} className={styles['fullscreen-panorama']} data-testid="FullscreenPanorama" />;
});
